import ConfigContext from 'contexts/ConfigContext';
import { useContext } from 'react';

export default () => useContext(ConfigContext);
